import { render, staticRenderFns } from "./EmailCouponComponent.vue?vue&type=template&id=3dabf0ea"
import script from "./EmailCouponComponent.vue?vue&type=script&lang=js"
export * from "./EmailCouponComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports